module.exports = __webpack_public_path__ + "static/media/maciek1.ec5b72cc.jpg";